import { render, staticRenderFns } from "./OrderActionBill.vue?vue&type=template&id=5098ab88&"
import script from "./OrderActionBill.vue?vue&type=script&lang=ts&"
export * from "./OrderActionBill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports